module.exports = __webpack_public_path__ + "static/media/signin-background.9a7653bc.png";